import CrudPage from "@/components/admin/CrudPage";

const fields = [
  { name: "name", label: "Nama", required: true },
  { name: "position", label: "Jabatan", required: true, placeholder: "Ketua DKM, Sekretaris, Bendahara..." },
  { name: "phone", label: "No. HP" },
  { name: "period", label: "Periode" },
  { name: "order", label: "Urutan Tampil", type: "number" },
  { name: "photo_path", label: "Foto", type: "image", folder: "people", full: true },
];

const columns = [
  { key: "order", label: "#", className: "w-12 text-center" },
  { key: "name", label: "Nama", className: "font-medium" },
  { key: "position", label: "Jabatan" },
  { key: "phone", label: "Kontak", className: "text-slate-500" },
  { key: "period", label: "Periode", className: "text-slate-500" },
];

export default function Pengurus() {
  return (
    <CrudPage
      title="Pengurus DKM"
      subtitle="Struktur Dewan Kemakmuran Masjid Al-Iman"
      endpoint="board"
      prefix="admin-board"
      itemLabel="Pengurus"
      fields={fields}
      columns={columns}
      defaults={{ name: "", position: "", phone: "", period: "2024-2029", order: 10, photo_path: "" }}
      searchKeys={["name", "position"]}
    />
  );
}
